import { useEffect, useState } from "react";

const QodefBackgroundText = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      init();
    };

    const handleScroll = () => {
      showHideBackToTop();
    };

    window.addEventListener("load", init);
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("load", init);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const init = () => {
    const elements = document.querySelectorAll(".qodef-background-text");
    elements.forEach((element) => {
      responsiveOutputHandler(element);
    });
  };

  const responsiveOutputHandler = (element) => {
    const breakpoints = {
      3840: 1513,
      1512: 1369,
      1368: 1201,
      1200: 1,
    };

    for (const [maxWidth, minWidth] of Object.entries(breakpoints)) {
      if (windowWidth <= maxWidth && windowWidth >= minWidth) {
        generateResponsiveOutput(element, maxWidth);
        break;
      }
    }
  };

  const generateResponsiveOutput = (element, width) => {
    const backgroundText = element.querySelector(".qodef-m-background-text");
    if (backgroundText) {
      backgroundText.style.fontSize = `${backgroundText.dataset[`size-${width}`]}px`;
      backgroundText.style.top = `${backgroundText.dataset[`vertical-offset-${width}`]}px`;
    }
  };

  const showHideBackToTop = () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const offset = scrollTop > 0 ? scrollTop + windowHeight / 2 : 1;
    const backToTop = document.getElementById("qodef-back-to-top");
    if (backToTop) {
      if (offset < 1000) {
        backToTop.classList.add("qodef--off");
        backToTop.classList.remove("qodef--on");
      } else {
        backToTop.classList.add("qodef--on");
        backToTop.classList.remove("qodef--off");
      }
    }
  };

  return (
    <>
      {/* <div className="qodef-background-text">
        <span className="qodef-m-background-text" data-size-3840="40" data-vertical-offset-3840="10">Sample Text</span>
      </div> */}
      <a id="qodef-back-to-top" href="#" className="qodef--predefined qodef--on">
        <span className="qodef-back-to-top-icon">
          <svg className="qodef-svg--back-to-top qodef-e-back-to-top-icon" xmlns="http://www.w3.org/2000/svg" width="15.767" height="15.767" viewBox="0 0 15.767 15.767">
            <g fill="none" stroke="currentColor" strokeWidth="2">
              <path d="m.707 8.59 7.176-7.176L15.06 8.59"></path>
              <path d="M7.884 1.414v14.352"></path>
            </g>
            <g fill="none" stroke="currentColor" strokeWidth="2">
              <path d="m.707 8.59 7.176-7.176L15.06 8.59"></path>
              <path d="M7.884 1.414v14.352"></path>
            </g>
          </svg>
        </span>
      </a>
    </>
  );
};

export default QodefBackgroundText;
